import api from "./config.js";

    // Obtener todas las reservas
    export const getReservas = async () => {
    const { data } = await api.get("/reservas");
    return Array.isArray(data) ? data : data.reservas || [];
    };

    // Obtener una reserva por ID
    export const getReserva = async (id) => {
    const { data } = await api.get(`/reservas/${id}`);
    return data;
    };

    // Crear una nueva reserva
    export const createReserva = async (reserva) => {
    const { data } = await api.post("/reservas", reserva);
    return data;
    };

    // Actualizar reserva
    export const updateReserva = async (id, reserva) => {
    const { data } = await api.put(`/reservas/${id}`, reserva);
    return data;
    };

    // Eliminar reserva
    export const deleteReserva = async (id) => {
    const { data } = await api.delete(`/reservas/${id}`);
    return data;
    };
